<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system/index';
	import { mobile } from 'src/services/mobile-rework';
	import { createEventDispatcher, onMount } from 'svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	const dispatch = createEventDispatcher();

	export let showModal: boolean;

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', onCloseModal);
			return () => mobile.removeEventListener('back_button', onCloseModal);
		}
	});

	const onCloseModal = () => {
		if (showModal) showModal = false;
	};

	const installerLogoutHandler = async () => {
		onCloseModal();
		dispatch('switch');
	};
</script>

<Modal
	{showModal}
	on:close={onCloseModal}
	title={$format('title_modal_exit_customer_profile', {
		default: 'Are you sure you want to exit the customer profile?',
	})}
>
	<Container slot="content" padding="0">
		<Text>
			{$format('text_modal_exit_customer_explanation', {
				default:
					"Currently, you are in the customer profile through your installers portal and if you decide to leave it, you'll not be able to return to this profile from here. You'll need to access it again from the customer app link from the installer's portal.",
			})}
		</Text>
	</Container>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			variant="secondary"
			on:click={onCloseModal}
		>
			{$format(`button_cancel`, { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			on:click={installerLogoutHandler}
		>
			{capFirstChar($format('logout', { default: 'Log out' }))}
		</Button>
	</div>
</Modal>
